var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 40 40",
      "width": "40",
      "height": "40",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22.8184 20.3398C22.8184 20.5352 22.7402 20.7109 22.5938 20.8574L15.2402 27.9375C15.1035 28.0742 14.9277 28.1523 14.7227 28.1523C14.3223 28.1523 14.0098 27.8398 14.0098 27.4297C14.0098 27.2246 14.0879 27.0586 14.2148 26.9219L21.0605 20.3398L14.2148 13.748C14.0879 13.6113 14.0098 13.4355 14.0098 13.2402C14.0098 12.8301 14.3223 12.5273 14.7227 12.5273C14.9277 12.5273 15.1035 12.5957 15.2402 12.7324L22.5938 19.8125C22.7402 19.959 22.8184 20.1348 22.8184 20.3398Z",
      "fill": _vm.fill
    }
  }), _c('line', {
    attrs: {
      "x1": "0.6",
      "y1": "-0.6",
      "x2": "16.4",
      "y2": "-0.6",
      "transform": "matrix(5.9139e-08 1 1 -5.9139e-08 26 12)",
      "stroke": _vm.fill,
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }